import React from 'react'
import { Grid, Container, Card, CardContent, Typography } from '@material-ui/core'
import HeaderImage from './HeaderImage'

const About = () => {

    return (
        <React.Fragment>
            <HeaderImage title="About Us" />
            <Container>
                <Grid container justify='center'>
                    <Grid item xs={12} sm={8}>
                        <Card>
                            <CardContent>

                                <Typography component="p" variant="body1" align="left" color="primary">
                                    At DesiCooks, we wish to offer our personal rendition of Indian gourmet cuisine with an innovative gastronomic
                                    take on traditional cooking methods, fine Indian produce and the legacy of our shared food heritage. Moreover,
                                    we regard it as a personal challenge to help bring about a revival of Indian cuisine and let its distinctive
                                    flavours and particular regional character brighten up the world.
                            </Typography>

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    )
}

export default About